import React, { useState } from 'react';
import { Accordion, Button, Col, Form, Row } from 'react-bootstrap';
import { BsFillTrashFill } from 'react-icons/bs';

import { useFormikContext } from 'formik';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { ConfirmationModal } from '@components/Modals';
import { Page500 } from '@containers/ErrorPages/Page500';

export const ShadowRouting = ({ did, getQuery, deleteQuery }) => {
  const { values, handleChange, handleBlur } = useFormikContext();
  const { data, isLoading, status } = getQuery;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (isLoading) {
    return (
      <>
        <Accordion.Header>Shadow routing number</Accordion.Header>
        <Accordion.Body>
          <DefaultSpinnerCenter />
        </Accordion.Body>
      </>
    );
  }
  if (status === 'rejected') {
    return <Page500 />;
  }
  return (
    <>
      <Accordion.Header>Shadow routing number</Accordion.Header>
      <Accordion.Body>
        <Row className="normalFontSize">
          <Col md={5}>Shadow routing number</Col>
          <Col md={2}>Delete</Col>
        </Row>
        <hr />
        <Form.Group
          as={Row}
          className="mb-3"
          controlId="formGroupShadowRouting"
        >
          <Col md={5}>
            <Form.Control
              name="shadowRoutingNumber"
              size="sm"
              value={values.shadowRoutingNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Enter shadow routing number"
            />
          </Col>
          <Col md={2}>
            <Button
              variant="didxl"
              onClick={handleShow}
              disabled={Boolean(!data?.id)}
            >
              <BsFillTrashFill size={17} />
            </Button>
            <ConfirmationModal
              message={`Do you want to clear the shadow routing number for DID - ${did}?`}
              show={show}
              onHide={handleClose}
              handleConfirm={() => deleteQuery({ did, id: data?.id })}
            />
          </Col>
        </Form.Group>
      </Accordion.Body>
    </>
  );
};
